import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetSuppliersAndManufacturersDto from "./dto/get-suppliers-and-manufacturers.dto";

export const SuppliersAndManufacturersEffectActions = {
  getAllSuppliersAndManufacturers: `${Entities.SuppliersAndManufacturers}_getAllSuppliersAndManufacturers`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.SuppliersAndManufacturers,
  initSchema,
  aliasName: DIContainerKeys.SuppliersAndManufacturersService,
})
export class SuppliersAndManufacturersService extends HttpService {
  @loader(Loaders.GetSupplierAndManufacturersLoader)
  @action(DIContainerKeys.SuppliersAndManufacturersService)
  public *getAllSuppliersAndManufacturers(dto: GetSuppliersAndManufacturersDto): any {
    yield this.setLoaderState(Loaders.GetSupplierAndManufacturersLoader, true);
    const body = dto?.body ?? {};
    const response = yield call(
      this.post,
      {
        url: dto?.isForClientPage ? BASE_API_PATHS.getClientAllSupplierManufacturer : BASE_API_PATHS.getMSPAllSupplierManufacturer,
        domain: API_DOMENS.CC_API,
        body: this.toFormData(body),
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetSupplierAndManufacturersLoader, false);
      return;
    }
    const state = yield this.di.reduxStore.state()?.[Entities.SuppliersAndManufacturers];
    const { mr, ...data } = response;

    const payload = dto?.isForClientPage ? {
      ...state,
      ...data,
      ClientRowData_List: data?.ClientRowData_List
    } : {
      ...state,
      ...data,
      MSPClientRowData_List: data?.MSPClientRowData_List,
      MSPSupplierManufacturer_List: data?.MSPSupplierManufacturer_List
    }

    // const payload = dto?.isForClientPage ? {
    //   ...state,
    //   ...data,
    //   ClientRowData_List: dto?.body?.SupplierNumber === 0
    //     ? data?.ClientRowData_List
    //     : data?.ClientRowData_List?.reduce((acc: any, curr: any) => {
    //       const index = acc?.findIndex((item: any) => item?.ClientId === curr?.ClientId);
    //       if (index >= 0) {
    //         acc[index] = curr;
    //       } else {
    //         acc.push(curr);
    //       }
    //       return acc;
    //     }, [...state?.ClientRowData_List]),
    // } : {
    //   ...state,
    //   ...data,
    //   MSPClientRowData_List: dto?.body?.SupplierNumber === 0
    //     ? data?.MSPClientRowData_List
    //     : data?.MSPClientRowData_List?.reduce((acc: any, curr: any) => {
    //       const index = acc?.findIndex((item: any) => item?.objId_Customer === curr?.objId_Customer);
    //       if (index >= 0) {
    //         acc[index] = curr;
    //       } else {
    //         acc.push(curr);
    //       }
    //       return acc;
    //     }, [...state?.MSPClientRowData_List]),

    //   MSPSupplierManufacturer_List: dto?.body?.SupplierNumber === 0
    //     ? data?.MSPSupplierManufacturer_List : data?.MSPSupplierManufacturer_List?.reduce((acc: any, curr: any) => {
    //       const index = acc?.findIndex((item: any) => item?.SupplierId === curr?.SupplierId);
    //       if (index >= 0) {
    //         acc[index] = curr;
    //       } else {
    //         acc.push(curr);
    //       }
    //       return acc;
    //     }, [...state?.MSPSupplierManufacturer_List]),
    // }

    yield this.setEntityState(Entities.SuppliersAndManufacturers, payload);
    yield this.setLoaderState(Loaders.GetSupplierAndManufacturersLoader, false);
  }
}
